import { useEffect, useState } from 'react';
import { wsManager } from '../services/websocketManager';
import type { ConnectionStatus } from '../services/websocketManager';
import { ConnectionStatus as CS } from '../services/websocketManager';

// This hook ONLY tracks connection status, not opportunities
// Used by ConnectionStatus component to avoid duplicate subscriptions
export const useConnectionStatus = () => {
  const [status, setStatus] = useState<ConnectionStatus>(CS.DISCONNECTED);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [opportunityCount, setOpportunityCount] = useState(0);
  
  useEffect(() => {
    // Subscribe to status changes
    const unsubscribeStatus = wsManager.onStatusChange((newStatus) => {
      setStatus(newStatus);
      setReconnectAttempts(wsManager.getReconnectAttempts());
    });
    
    // Update opportunity count periodically (without subscribing to lifecycle)
    const updateCount = () => {
      setOpportunityCount(wsManager.getCache().size);
    };
    
    // Initial count
    updateCount();
    
    // Update count every second
    const interval = setInterval(updateCount, 1000);
    
    // Cleanup on unmount
    return () => {
      unsubscribeStatus();
      clearInterval(interval);
    };
  }, []);
  
  const reconnect = () => {
    wsManager.disconnect();
    setTimeout(() => wsManager.connect(), 100);
  };
  
  return {
    status,
    reconnectAttempts,
    opportunityCount,
    reconnect,
    isConnected: status === CS.CONNECTED,
    isReconnecting: status === CS.RECONNECTING,
  };
};